import { FC } from 'react';
import { IconProps } from '../../types';

export const Bronze1: FC<IconProps> = ({ width = 15, height = 15, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5Z"
        fill="url(#paint0_linear_6141_58164)"
      />
      <path
        d="M3.36619 3.588H4.86619C5.39419 3.6 5.87419 3.6 6.33019 3.936C6.63019 4.152 6.78619 4.404 6.87019 4.74C6.96619 5.136 6.97819 5.844 6.97819 5.868C6.97819 6.012 6.97819 6.768 6.59419 7.284C6.45019 7.464 6.29419 7.584 6.11419 7.728C6.35419 7.836 6.46219 7.896 6.55819 7.968C6.82219 8.184 7.12219 8.664 7.12219 9.492C7.12219 9.612 7.11019 10.416 6.89419 10.956C6.84619 11.064 6.76219 11.256 6.55819 11.484C6.15019 11.904 5.68219 11.952 5.47819 11.976C5.08219 12.024 4.33819 12.024 3.36619 12.024V3.588ZM4.55419 8.172V11.028C4.93819 11.028 5.29819 11.028 5.57419 10.764C5.80219 10.56 5.93419 10.296 5.93419 9.696C5.93419 9.612 5.92219 9.024 5.71819 8.64C5.68219 8.58 5.61019 8.46 5.44219 8.352C5.17819 8.172 4.87819 8.172 4.55419 8.172ZM4.55419 4.56V7.26C5.14219 7.272 5.34619 7.212 5.56219 6.984C5.73019 6.792 5.86219 6.516 5.86219 5.94C5.86219 5.856 5.86219 5.664 5.81419 5.436C5.79019 5.28 5.70619 4.704 5.14219 4.56C4.95019 4.512 4.74619 4.536 4.55419 4.56ZM8.544 3.588H10.44V11.988H9.252V4.608H8.544V3.588Z"
        fill="#FCF7DE"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6141_58164"
          x1="7"
          y1="18"
          x2="7"
          y2="-3.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90674D" />
          <stop offset="0.239" stopColor="#6A2D20" />
          <stop offset="0.464" stopColor="#DFC4A1" />
          <stop offset="1" stopColor="#9B725A" />
        </linearGradient>
      </defs>
    </svg>
  );
};
